import { Preferences } from '@capacitor/preferences';

// Storage simples que combina localStorage e Preferences
export const appStorage = {
  async getItem(key: string): Promise<string | null> {
    try {
      // Tenta primeiro do localStorage
      const value = localStorage.getItem(key);
      if (value) return value;

      // Se não encontrar, tenta do Preferences
      const { value: prefValue } = await Preferences.get({ key });
      return prefValue;
    } catch {
      return null;
    }
  },
  async setItem(key: string, value: string): Promise<void> {
    try {
      localStorage.setItem(key, value);
      await Preferences.set({ key, value });
    } catch (error) {
      console.warn('Erro ao salvar dados:', error);
    }
  },
  async removeItem(key: string): Promise<void> {
    try {
      localStorage.removeItem(key);
      await Preferences.remove({ key });
    } catch (error) {
      console.warn('Erro ao remover dados:', error);
    }
  }
}; 